export const allowedUsers = [
  'shrenivass@sourcewiz.co',
  'kritagya@sourcewiz.co',
  'revanth@sourcewiz.co',
];
